export default {
  dummyImage: 'https://dummyimage.com/600x400/000000/ffffff&text=Image+Sample',
  translation: {
    home: {
      headerText: {
        candidate: 'header_text_candidate',
        hiringPartner: 'header_text_hiring_partner',
        cvMaker: 'header_text_cv_maker',
        signup: 'header_text_signup',
        login: 'header_text_login',
        register: 'header_text_register',
        contactUs: 'header_text_contact_us',
      },
      footerText: {
        candidate: 'footer_text_candidate',
        candidateMenus: [
          {
            key: 'footer_text_candidate_menu_1',
          },
          {
            key: 'footer_text_candidate_menu_2',
          },
          {
            key: 'footer_text_candidate_menu_3',
          },
          {
            key: 'footer_text_candidate_menu_4',
          },
        ],
        hiringPartner: 'footer_text_hiring_partner',
        hiringPartnerMenus: [
          {
            key: 'footer_text_hiring_partner_menu_1',
          },
          {
            key: 'footer_text_hiring_partner_menu_2',
          },
        ],
        company: 'footer_text_company',
        companyMenus: [
          {
            key: 'footer_text_company_menu_1',
          },
        ],
      },
    },
    general: {
      formLinkedInKey: 'form_linkedin_profile',
      formCompanyEmailKey: 'form_company_email',
      formFullNameKey: 'form_fullname',
      formWhatsappNumberKey: 'form_wa',
      formPhoneNumberKey: 'form_phone_number',
      formEmailKey: 'form_email',
      formPasswordKey: 'form_password',
      formNewPasswordKey: 'form_new_password',
      formConfirmPasswordKey: 'form_confirm_password',
      formUniversityKey: 'form_university',
      formEnglishProficiencyKey: 'form_english_proficiency',
      formOrganizationExpKey: 'form_organization_exp_key',
      formYOEKey: 'form_yoe_key',
      formRoleKey: 'form_role_key',
      formJobRoleKey: 'form_job_role_key',
      formJobTitleKey: 'form_job_title_key',
      formJobSeekingStatusKey: 'form_job_seeking_status_key',
      formJobLocationKey: 'form_job_location_key',
      formRoleCategoryKey: 'form_role_category_key',
      formIndustryPrefKey: 'form_industry_pref_key',
      formSalaryRangeKey: 'form_salary_range_key',
      formSalaryDiscloseKey: 'form_salary_disclose_key',
      formCVKey: 'form_cv_key',
      formAdditionalFilesKey: 'form_additional_file_key',
      formHowDoYouKnowTGKey: 'form_how_do_u_know_tg_key',
      formMajorKey: 'form_major',
      formGPAKey: 'form_gpa',
      formGenderKey: 'form_gender',
      formCollegePeriodKey: 'form_college_period',
      formCompanyNameKey: 'form_company_name',
      formCompanyBenefitsKey: 'form_company_benefits',
      formCompanyCulturesKey: 'form_company_cultures',
      formCompanyWorkingTypesKey: 'form_company_working_types',
      formCompanyDescKey: 'form_company_desc',
      formCompanyAddressKey: 'form_company_address',
      formCompanyWebKey: 'form_company_web',
      formCompanyIndustryKey: 'form_company_industry',
      formCompanyLocationKey: 'form_company_location',
      formCompanyLogoKey: 'form_company_logo',
      formCompanyHeaderKey: 'form_company_header',
      formCompanySizeKey: 'form_company_size',
      formCompanyAgreementKey: 'form_company_agreement',
      formCompanyEmployStatusKey: 'form_company_employ_status',
      formJobDurationKey: 'form_job_duration_status',
      formJobResponsibilityKey: 'form_job_responsibility',
      formJobRequirementKey: 'form_job_requirement',
      formTechnicalSolutionKey: 'form_technical_solution',
      formCustomTechnicalTest: 'form_custom_technical_test',
      formLoginButtonKey: 'header_text_login',
      formSignUpButtonKey: 'header_text_signup',
      formForgotPasswordButtonKey: 'button_text_forgotpass',
      formOpenEmailButtonKey: 'button_text_openemail',
      formChangePasswordButtonKey: 'button_text_forgotpass',
      formContinueButtonKey: 'button_text_continue',
      formPayNowButtonKey: 'button_text_pay_now',
      formNextButtonKey: 'button_text_next',
      formBackButtonKey: 'button_text_back',
      formBackEditCVButtonKey: 'button_text_back_edit_cv',
      formSaveButtonKey: 'button_text_save',
      formCancelButtonKey: 'button_text_cancel',
      formRefreshStatButtonKey: 'button_text_refresh_status',
      formDownloadCVButtonKey: 'button_text_download_my_cv',
      formDownloadInvoiceAndCVButtonKey: 'button_text_download_invoice_and_cv',
      formSendToEmailButtonKey: 'button_text_send_email_button_key',
      formRetryPaymentButtonKey: 'button_text_retry_payment',
      formConfirmButtonKey: 'button_text_confirm',
      formEnhanceButtonKey: 'button_text_enhance',
      formLoadingTextKey: 'form_loading_text',
      formGenerateContentLoadingTextKey: 'form_generating_content_loading_text',
    },
    login: {
      pageCandidateTitleKey: 'page_candidate_login_title',
      pageCandidateSubTitleKey: 'page_candidate_login_subtitle',
      pageCandidateContinueWithLabelKey: 'page_candidate_login_continue_with',
      pageHPTitleKey: 'page_hp_login_title',
      pageHPSubTitleKey: 'page_hp_login_subtitle',

      formErrorValidationMessageKey: 'page_login_error_validation',
      formSuccessValidationMessageKey: 'page_login_success',

      formSuccessSendEmailVerifyKey: 'page_email_verify_success',
    },
    basicInfo: {
      pageCandidateTitleKey: 'page_candidate_basicinfo_title',
      pageCandidateSubTitleKey: 'page_candidate_basicinfo_subtitle',
      pageCandidateWorkPreferenceTitleKey:
        'page_candidate_basicinfo_work_preference_title',
      pageCandidateWorkPreferenceSubTitleKey:
        'page_candidate_basicinfo_work_preference_subtitle',
      formErrorValidationMessageKey: 'page_basicinfo_error_validation',
      formErrorValidationStepTwoMessageKey:
        'page_basicinfo_error_validation_step_two',
      formSuccessConfirmActionKey: 'page_basicinfo_success_confirm',
    },
    searchJob: {
      formApplyButtonKey: 'button_text_apply',
      formApplyOnlyButtonKey: 'button_text_apply_only',
    },
    signup: {
      pageCandidateTitleKey: 'page_candidate_signup_title',
      pageHPTitleKey: 'page_hp_signup_title',
      pageHPSubtitleKey: 'page_hp_signup_subtitle',
      pageHiringPartnerTitleKey: 'page_hiring_partner_signup_title',
      pageHiringPartnerSubTitleKey: 'page_hiring_partner_signup_subtitle',
      pageCandidateSubTitleKey: 'page_candidate_signup_subtitle',
      pageCandidateContinueWithLabelKey: 'page_candidate_signup_continue_with',

      formErrorValidationMessageKey: 'page_signup_error_validation',
      formAfterSignUpMessageKey: 'page_signup_success',
    },
    forgotPass: {
      pageCandidateTitleKey: 'page_candidate_forgot_pass_title',
      pageCandidateSubTitleKey: 'page_candidate_forgot_pass_subtitle',
    },
    changePass: {
      pageCandidateTitleKey: 'page_candidate_change_pass_title',
      pageCandidateSubTitleKey: 'page_candidate_change_pass_subtitle',

      formErrorValidationMessageKey: 'page_changepass_error_validation',
      formSuccessValidationMessageKey: 'page_changepass_success',
      formReloginMessageKey: 'page_changepass_relogin_message',
    },
    resendPass: {
      pageCandidateTitleKey: 'page_candidate_resend_pass_title',
      pageCandidateSubTitleKey: 'page_candidate_resend_pass_subtitle',
    },
    resendPassSuccess: {
      pageCandidateTitleKey: 'page_candidate_resend_pass_success_title',
      pageCandidateSubTitleKey: 'page_candidate_resend_pass_success_subtitle',
    },
    profile: {
      formSuccessVerifyEmailKey: 'page_user_profile_verify_email_success',
      formSuccessSendResetPassKey: 'page_user_profile_reset_pass_success',
      formErrorValidationMessageKey:
        'page_user_profile_reset_pass_validation_failed',
      pageCandidateTitleKey: 'page_candidate_profile_title',
      pageCandidateSubTitleKey: 'page_candidate_profile_subtitle',
      pageCandidatePreferenceSubTitleKey:
        'page_candidate_profile_pref_subtitle',
      pageCandidateMyDocumentSubtitleKey:
        'page_candidate_profile_documents_subtitle',
      pageCandidateGeneralTestTitleKey:
        'page_candidate_basicinfo_general_test_title',
      pageCandidateCuratedJobs: 'page_candidate_curated_jobs_title',
      message: {
        updateProfileSuccess:
          'page_user_profile_message_profile_update_success',
        greeting: 'page_user_profile_message_greeting',
      },
    },
    notFound: {
      backToHomeHeaderKey: 'page_notfound_back_to_home_header_text',
      backToHomeKey: 'page_notfound_back_to_home_text',
    },
    cvMaker: {
      title: 'form_cv_maker_title',
      subtitle: 'form_cv_maker_subtitle',
      uploadTitle: 'form_cv_maker_upload_title',
      uploadSubtitle: 'form_cv_maker_upload_subtitle',
      parsingInProgressTitle: 'form_cv_maker_parsing_cv_inprogress_title',
      parsingInProgressSubtitle: 'form_cv_maker_parsing_cv_inprogress_subtitle',
      cvOwnTitle: 'form_cv_maker_own_title',
      cvOwnText: 'form_cv_maker_own_text',
      cvBuilderTitle: 'form_cv_maker_builder_title',
      cvBuilderText: 'form_cv_maker_builder_text',
      cvAIBuilderTitle: 'form_cv_ai_recommendation_title',
      cvAIBuilderText: 'form_cv_ai_recommendation_subtitle',
      cvAIBuilderText2: 'form_cv_ai_recommendation_subtitle_2',
      cvAIBuilderText3: 'form_cv_ai_recommendation_subtitle_3',
      cvPreviewTitle: 'form_cv_ai_cv_pdf_preview',
      endDateCheckboxPlaceholder: 'form_cv_end_date_checkbox',
      endDateCheckboxEduPlaceholder: 'form_cv_end_date_edu_checkbox',
      pendingPaymentTitle: 'form_cv_maker_pending_payment_title',
      pendingPaymentSubTitle: 'form_cv_maker_pending_payment_subtitle',
      successPaymentTitle: 'form_cv_maker_success_payment_title',
      successPaymentSubTitle: 'form_cv_maker_success_payment_subtitle',
      failedPaymentTitle: 'form_cv_maker_failed_payment_title',
      failedPaymentSubTitle: 'form_cv_maker_failed_payment_subtitle',
      paymentHelpTitle: 'form_cv_maker_payment_help',
      personalInfoTitle: 'form_cv_maker_personal_info_title',
      personalInfoSubtitle: 'form_cv_maker_personal_info_subtitle',
      eduInfoTitle: 'form_cv_maker_edu_info_title',
      eduInfoSubtitle: 'form_cv_maker_edu_info_subtitle',
      expInfoTitle: 'form_cv_maker_exp_info_title',
      expInfoSubtitle: 'form_cv_maker_exp_info_subtitle',
      dataInfoTitle: 'form_cv_maker_data_info_title',
      dataInfoSubtitle: 'form_cv_maker_data_info_subtitle',
      skillInfoTitle: 'form_cv_maker_skill_info_title',
      skillInfoSubtitle: 'form_cv_maker_skill_info_subtitle',
      skillInfoDesc: 'form_cv_maker_skill_info_desc',
      extraSectionTitle: 'form_cv_maker_extra_section_title',
      extraSectionSubtitle: 'form_cv_maker_extra_section_subtitle',
      extraSectionVolunteer: 'form_cv_maker_extra_section_volunteer_title',
      extraSectionProjects: 'form_cv_maker_extra_section_projects_title',
      extraSectionLanguage: 'form_cv_maker_extra_section_language_title',
      extraSectionCertification: 'form_cv_maker_extra_section_certif_title',
      extraSectionEmptyPlaceholder:
        'form_cv_maker_extra_section_empty_placeholder',
      paymentSubTitle: 'form_cv_maker_payment_subtitle',
      paymentTitle: 'form_cv_maker_payment_title',
      contactTitle: 'form_cv_maker_contact_title',
      contactLabel: 'form_cv_maker_contact_label',
      paymentMethodTitle: 'form_cv_maker_payment_method_title',
      paymentMethodLabel: 'form_cv_maker_payment_method_label',
      couponCodeTitle: 'form_cv_maker_coupon_title',
      couponCodeLabel: 'form_cv_maker_coupon_label',

      formCVName: 'form_cv_maker_cv_name',
      formJobTitle: 'form_cv_maker_job_title',
      formJobType: 'form_cv_maker_job_type',
      formJobDesc: 'form_cv_maker_desc',
      formJobDescTitle: 'form_cv_maker_jobdesc_title',
      formJobDescAIPrompt: 'form_cv_maker_desc_for_ai_prompt',
      formExp: 'form_cv_maker_exp',
      formFullName: 'form_cv_full_name',
      formSummary: 'form_cv_prof_summary',
      formSummaryDefault: 'form_cv_prof_summary_default',
      formLoremIpsumShorter: 'form_cv_lorem_ipsum_shorter',
      formSummaryPlaceholder: 'form_cv_prof_summary_placeholder',
      formExpPlaceholder: 'form_cv_experience_placeholder',
      formEduPlaceholder: 'form_cv_education_placeholder',
      formCity: 'form_cv_city',
      formCountry: 'form_cv_country',
      formEmail: 'form_cv_email',
      formEmployer: 'form_cv_employer',
      formStartDate: 'form_cv_start_date',
      formEndDate: 'form_cv_end_date',
      formLocation: 'form_cv_location',
      formPhoneNumber: 'form_cv_phone_number',
      formAdditionalLink: 'form_cv_additional_links',
      formSchoolName: 'form_cv_school_name',
      formSkillName: 'form_cv_skill_name',
      formDegree: 'form_cv_degree',
      formMajor: 'form_major',
      formAchievements: 'form_cv_achievements',
    },
  },
  forms: {
    salaryRange: {
      min: 500000,
      max: 50000000,
    },
    salaryStep: 1000,
    salaryRangePlaceholder: {
      min: '500.000',
      max: '50.000.000',
    },
    experience: {
      levels: [
        {
          label: 'No experience',
        },
        {
          label: 'Entry level (6 months - 3 years)',
        },
        {
          label: 'Mid level (3 - 5 years)',
        },
        {
          label: 'Senior level (5+ years)',
        },
      ],
    },
  },
  regex: {
    linkedInProfile:
      // eslint-disable-next-line max-len
      /^(https:\/\/)?(www\.|id\.)?linkedin\.com\/(in|sg)\/[a-zA-Z0-9\-_%]{5,30}\/?$/,
    phoneNumber: /^(\(?\d{2,4}\)?[-\s]?)?\d{3,4}[-\s]?\d{3,4}$/,
  },
};
